/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_AmenitiesInputs */

const cs_builder_block_amenities = /** @type {(inputs: Builder_Block_AmenitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybavení`)
};

const en_builder_block_amenities = /** @type {(inputs: Builder_Block_AmenitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amenities list`)
};

/**
* | output |
* | --- |
* | "Amenities list" |
*
* @param {Builder_Block_AmenitiesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_amenities = /** @type {((inputs?: Builder_Block_AmenitiesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_AmenitiesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_amenities(inputs)
	return cs_builder_block_amenities(inputs)
});